import Vue from 'vue'
import App from './calendar/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const calendar = document.getElementById('calendar-vue');

  if (calendar) {
    new Vue({
      el: '#calendar-vue',
      render: h => h(App)
    }).$mount();
  }
});